import { UPDATE_SCREEN } from '../Types';

export const updateScreen = (screenName, content) => ({ type: UPDATE_SCREEN, screenName, content });
